import { request } from '@umijs/max';

// 获取支付记录分页列表
export async function getUserPayPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/userPay/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ['shop', 'operator', 'user', 'order', 'refundList'],
    },
  });
}

// 获取支付详情
export async function getUserPayInfo(values: API.FormValues) {
  return request('/api/admin/userPay/info', {
    method: 'POST',
    data: {
      ...values,
      with: ['shop', 'operator', 'user', 'order', 'refundList'],
    },
  });
}
